interface UserWithId {
  Id?: number;
}

// An automation stores a Requester / Affected Users value as the users' PlatformUser ids, comma-separated. A user
// that could not be resolved is left out rather than written as an empty entry (#35509).
export const toUserIdList = (users: (UserWithId | null | undefined)[]): string =>
  users.filter(user => !!user?.Id).map(user => user.Id).join(',');
